import {Brick, registerBrick, Transaction} from 'olympe';
import BCP from './DM_BCP.js';

// noinspection JSUnusedGlobalSymbols
export default class UpdateNotificationPropsInBCP extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} bCPData
     * @param {function()} forwardEvent
     */
    update($, [bCPData], [forwardEvent]) {
        // Write your code here. You have to implement this method !
        // Executed every time the brick receives a new trigger event, override `setupExecution()` to change the behavior.

        const t = new Transaction(true);
        bCPData.forEach(x => {
            x.content.forEach((y) => {
                BCP.setNotification_stage(t, y.bcpRequest, y.workflowState);
            });
        });
        t.execute()
            .catch((reason) => {
                console.error(`018a052729c977818d84: could not update notification prop for BCP request: ${reason}`);
            })
            .finally(
                () => forwardEvent()
            );
    }
}

registerBrick('018a052729c977818d84', UpdateNotificationPropsInBCP);
